import { calculatePosition } from './calculate-position';
import { findUpUntil, getContainingBlock } from '../../../../core/utils/src/dom';
var PositioningController = /** @class */ (function () {
    function PositioningController(component) {
        var _this = this;
        this.component = component;
        this.updatePosition = function () { };
        this.recalculatePosition = function () {
            if (!_this.component.isOpen()) {
                return;
            }
            var trigger = _this.component.getNode().querySelector('.awsui-popover__trigger');
            var popover = _this.component.getNode().querySelector('.awsui-popover__body');
            var dismiss = _this.component.getNode().querySelector('.awsui-popover__dismiss');
            var containingBlock = getContainingBlock(popover);
            // Reset previous popover placement (to give it room to grow)
            popover.style.top = '0';
            popover.style.left = '0';
            popover.style.width = 'auto';
            popover.style.height = 'auto';
            // HACK: maximize width for column layouts
            if (popover.querySelector('awsui-column-layout')) {
                popover.style.width = '100%';
            }
            var dismissDelta = 0;
            if (dismiss) {
                var dismissWidth = dismiss.getBoundingClientRect().width || 0;
                // HACK: hide dismiss button to compute popover dimensions without wrappings due to it
                dismiss.style.display = 'none';
                var header = popover.querySelector('.awsui-popover__header');
                var content = popover.querySelector('.awsui-popover__content');
                var headerWidth = header
                    ? header.children.length > 0
                        ? header.children[0].getBoundingClientRect().width
                        : header.getBoundingClientRect().width
                    : 0;
                var contentWidth = header && content
                    ? content.children.length > 0
                        ? content.children[0].getBoundingClientRect().width
                        : content.getBoundingClientRect().width
                    : 0;
                dismissDelta = Math.max(dismissWidth - Math.max(contentWidth - headerWidth, 0), 0);
            }
            // Get rects representing key elements
            var triggerRect = trigger.getBoundingClientRect();
            var viewportRect = getViewportRect();
            var containingBlockRect = containingBlock ? containingBlock.getBoundingClientRect() : viewportRect;
            // Round up dimensions (IE11 doesn't handle subpixels too accurately)
            var popoverRect = popover.getBoundingClientRect();
            var popoverRectCeil = {
                top: popoverRect.top,
                left: popoverRect.left,
                width: Math.ceil(popoverRect.width + dismissDelta),
                height: Math.ceil(popoverRect.height)
            };
            // The container (as opposed to the viewport) is the element that forms the outermost
            // edge of where the popover can be rendered. If you have to scroll to see an opened
            // popover, it isn't the end of the world, but if the popover is rendered outside the
            // body, it's an issue.
            var container = (function () {
                if (containingBlock) {
                    return containingBlockRect;
                }
                var applayoutScrollableArea = findUpUntil(popover.parentElement, function (element) {
                    return element.className === 'awsui-app-layout__content';
                });
                // If the popover is used inside a v2 AppLayout (which has its own scrolling on the content region,
                // instead of using the document scrolling), the documentElement does not match the perceived size
                // of the page content, so we have to use the dimensions of the scrolling region instead.
                if (applayoutScrollableArea && applayoutScrollableArea.scrollHeight > applayoutScrollableArea.clientHeight) {
                    return applayoutScrollableArea.querySelector('.awsui-app-layout__content--scrollable').getBoundingClientRect();
                }
                return document.documentElement.getBoundingClientRect();
            })();
            // Calculate the arrow direction and viewport-relative position of the popover.
            var _a = calculatePosition(_this.component.getPreferredPosition(), triggerRect, popoverRectCeil, container, viewportRect), actualPosition = _a.actualPosition, boundingOffset = _a.boundingOffset;
            // redisplay dismiss
            if (dismiss) {
                dismiss.style.display = 'inline';
            }
            // Get the position of the popover relative to the offset parent.
            var popoverOffset = toRelativePosition(boundingOffset, containingBlockRect);
            // Set the popover's arrow direction.
            _this.component.setActualPosition(actualPosition);
            // Position the popover
            popover.style.width = boundingOffset.width + "px";
            popover.style.top = popoverOffset.top + "px";
            popover.style.left = popoverOffset.left + "px";
            // Cache the distance between the trigger and the popover (which stays the same as you scroll),
            // and use that to recalculate the new popover position.
            var triggerRelativeOffset = toRelativePosition(popoverOffset, toRelativePosition(triggerRect, containingBlockRect));
            _this.updatePosition = function () {
                var newTriggerOffset = toRelativePosition(trigger.getBoundingClientRect(), containingBlock ? containingBlock.getBoundingClientRect() : viewportRect);
                popover.style.top = newTriggerOffset.top + triggerRelativeOffset.top + "px";
                popover.style.left = newTriggerOffset.left + triggerRelativeOffset.left + "px";
            };
            _this.onScroll();
        };
        this.onScroll = function () {
            if (_this.component.isOpen()) {
                if (_this.animationFrame) {
                    cancelAnimationFrame(_this.animationFrame);
                }
                _this.animationFrame = requestAnimationFrame(_this.updatePosition);
            }
        };
    }
    PositioningController.prototype.addEventListeners = function () {
        window.addEventListener('resize', this.recalculatePosition);
        document.addEventListener('scroll', this.onScroll, true);
    };
    PositioningController.prototype.removeEventListeners = function () {
        window.removeEventListener('resize', this.recalculatePosition);
        document.removeEventListener('scroll', this.onScroll, true);
    };
    return PositioningController;
}());
export default PositioningController;
/**
 * Get a BoundingOffset that represents the visible viewport.
 */
function getViewportRect() {
    return {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight
    };
}
/**
 * Convert a viewport-relative offset to an element-relative offset.
 */
function toRelativePosition(element, parent) {
    return {
        top: element.top - parent.top,
        left: element.left - parent.left
    };
}
//# sourceMappingURL=positioning-controller.js.map